import { render, staticRenderFns } from "./MessageTemplateByShiseidoProduct.vue?vue&type=template&id=63490fba&scoped=true"
import script from "./MessageTemplateByShiseidoProduct.vue?vue&type=script&lang=js"
export * from "./MessageTemplateByShiseidoProduct.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateByShiseidoProduct.vue?vue&type=style&index=0&id=63490fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63490fba",
  null
  
)

export default component.exports